import React from 'react';

import { ConditionalRender, Skeleton, Stack, Typography } from '@crossnokaye/ux-common';
import {
  Header,
  HeaderRightActions,
  HeaderTitle,
  HeaderTitleGroup,
} from '@crossnokaye/ux-common/ckds';

interface SectionTemplateProps {
  title: string;
  children: React.ReactNode;
  isLoading?: boolean;
  rightButtons?: React.ReactNode;
}

export const SubSectionTemplate = ({
  title,
  children,
  isLoading,
  rightButtons,
}: SectionTemplateProps): React.ReactNode => {
  return (
    <div data-component="SubSectionTemplate">
      <ConditionalRender condition={!isLoading} fallback={<Skeletons />}>
        <Header
          className="bg-[#191919] mb-thin" // TODO: conver to ux-common color.  this is from the designs but not in ux-common yet.
        >
          <HeaderTitleGroup>
            <HeaderTitle>
              <Typography variant="h4">{title}</Typography>
            </HeaderTitle>
          </HeaderTitleGroup>
          {rightButtons != null && <HeaderRightActions>{rightButtons}</HeaderRightActions>}
        </Header>
        <Stack gap="thin">{children}</Stack>
      </ConditionalRender>
    </div>
  );
};

const Skeletons = () => {
  return (
    <div className="mb-stack-sm">
      <Skeleton className="w-full h-8 mb-thin" />
      <Skeleton className="w-full h-32 mb-thin" />
    </div>
  );
};
